module.exports = "<div class='row'>\r\n  <div class='col'>\r\n    <div style='margin-left:10px' *ngIf='loaded === true'>\r\n      <span class='data-quality-notice'>Is everything correct? If not, please contact us via email at <a\r\n          href='mailto:{{dataQuality.ContactEmailAddress}}'>{{dataQuality.ContactEmailAddress}}</a>\r\n        or, call us on: {{dataQuality.ContactTelephoneNumber}}.\r\n      </span>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-quality-link/data-quality-link.component.html
// module id = ./src/app/components/data-quality-link/data-quality-link.component.html
// module chunks = main